import { ComponentType } from 'react'
import { useRouter } from 'next/router'
/**
 * Next.js is a toy and can't make their hook hydrate with the URL
 * param on initial render. Use this wrap for any next.js page that doesn't
 * have a getStaticProps call.
 *
 * Info: https://github.com/vercel/next.js/discussions/11484
 */
export const withReadyRouter =
  (Component: ComponentType<any>) =>
  // eslint-disable-next-line react/display-name
  (props: any) => {
    const { isReady } = useRouter()

    if (!isReady) return null
    return <Component {...props} />
  }
